var exports = {
  "DD": "title__GYdaGy",
  "G2": "titleHeader__kMnM-6",
  "PL": "titleDescription__0NyLaH",
  "pW": "leadingVisual__Bn7bO-",
  "Kj": "requiredLabel__QQoOzL",
};

module.exports = exports;
